export const INQUIRE = 'BILLER/inquire';
export const VALIDATE = 'BILLER/validate';
export const PAY = 'BILLER/pay';
